module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input",
    attrs: {
      "id": "input"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "input",
    staticClass: "inputs",
    style: ({
      'background': (_vm.bgWhite ? '' : '#f5f7fa')
    }),
    attrs: {
      "id": "inputs",
      "name": "",
      "placeholder": _vm.params[_vm.type].placeholder,
      "autocomplete": "new-password",
      "readonly": _vm.readonly
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "focus": function($event) {
        _vm.bgWhite = true
      },
      "blur": function($event) {
        _vm.bgWhite = false
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.enterInput($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), (this.type === 'password' || this.type === 'newpassword') ? _c('div', {
    staticClass: "password",
    attrs: {
      "id": "password"
    }
  }, [_c('div', {
    staticClass: "password-icon",
    style: ({
      marginTop: (this.type === 'password' && _vm.$route.path !== '/invite/accountexist' && _vm.$route.path !== '/invite/invitenext' ? '-42px' : '-33px')
    }),
    on: {
      "click": _vm.showPasswordOrNot
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputType === 'text'),
      expression: "inputType === 'text'"
    }],
    attrs: {
      "src": require("../../assets/images/new-login-2018/showpassword.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputType === 'password'),
      expression: "inputType === 'password'"
    }],
    attrs: {
      "src": require("../../assets/images/new-login-2018/hidepassword.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type === 'password' && _vm.$route.path !== '/invite/accountexist' && _vm.$route.path !== '/invite/invitenext'),
      expression: "this.type === 'password' && $route.path !== '/invite/accountexist' && $route.path !== '/invite/invitenext'"
    }],
    staticClass: "password-remember",
    on: {
      "click": _vm.rememberPassword
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rememberpw),
      expression: "rememberpw"
    }],
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "src": require("../../assets/images/new-login-2018/tickle.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rememberpw),
      expression: "!rememberpw"
    }],
    staticStyle: {
      "margin-right": "4px"
    },
    attrs: {
      "src": require("../../assets/images/new-login-2018/no-tickle.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("remember password")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type === 'newpassword'),
      expression: "this.type === 'newpassword'"
    }],
    staticClass: "password-level"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordLevel > 0),
      expression: "passwordLevel > 0"
    }],
    staticClass: "level",
    staticStyle: {
      "background": "#f06f6f"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordLevel > 1),
      expression: "passwordLevel > 1"
    }],
    staticClass: "level",
    staticStyle: {
      "background": "#ffbf62"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordLevel > 2),
      expression: "passwordLevel > 2"
    }],
    staticClass: "level",
    staticStyle: {
      "background": "#4db74d"
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d383fd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Inputs.vue
// module id = 720
// module chunks = 1